import React from 'react';

function Footer({ loja, onMeusPedidosClick, onLoginClick, onCriarContaClick }) {
  const currentYear = new Date().getFullYear();
  
  const formatarEndereco = (endereco) => {
    if (!endereco) return null;
    if (typeof endereco === 'string') return endereco;
    const { logradouro, numero, bairro, cidade, uf } = endereco;
    return `${logradouro}${numero ? ', ' + numero : ''} - ${bairro}, ${cidade}/${uf}`;
  };

  const getHorarioHoje = () => {
    if (!loja?.horarios || loja.horarios.length === 0) return null;
    
    const today = new Date();
    const diasSemana = [1, 2, 4, 8, 16, 32, 64];
    const diaAtual = diasSemana[today.getDay()];
    const horarioHoje = loja.horarios.find(h => h.dia === diaAtual && h.ativo);
    
    if (!horarioHoje) return { status: 'Hoje fechado', horario: null };
    return { 
      status: 'Hoje aberto', 
      horario: `${horarioHoje.horario_inicial.substring(0, 5)} - ${horarioHoje.horario_final.substring(0, 5)}`
    };
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '15px' }}>
            <img
              src={loja?.logo_url ? `https://grubupload.s3.amazonaws.com/${loja.logo_url}` : 'https://grubicons.s3.us-east-1.amazonaws.com/foto-padrao-grub-digital.jpg'}
              alt={loja?.nome || 'Logo'}
              style={{ width: '48px', height: '48px', borderRadius: '8px', objectFit: 'cover' }}
              onError={(e) => { e.target.src = 'https://grubicons.s3.us-east-1.amazonaws.com/foto-padrao-grub-digital.jpg'; }}
            />
            <h3 style={{ margin: 0 }}>{loja?.nome || 'GRUB DIGITAL'}</h3>
          </div>
          <div className="footer-contact" style={{ textAlign: 'left' }}>
            {loja?.telefone && <p>{loja.telefone}</p>}
            {loja?.email && <p>{loja.email}</p>}
            {loja?.endereco && <p>{formatarEndereco(loja.endereco)}</p>}
            {loja?.horarios && loja.horarios.length > 0 && (() => {
              const info = getHorarioHoje();
              const isOpen = info?.horario !== null;
              return info && (
                <>
                  <p style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{
                      width: '8px',
                      height: '8px',
                      borderRadius: '50%',
                      backgroundColor: isOpen ? '#10b981' : '#ef4444',
                      animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
                    }} />
                    {info.status}{info.horario && `, ${info.horario}`}
                  </p>
                  <p style={{ margin: 0 }}>
                    <a href="/" style={{ color: '#666', textDecoration: 'none', fontSize: '0.85rem' }}>Veja todos os horários</a>
                  </p>
                </>
              );
            })()}
          </div>
        </div>

        <div className="footer-section" style={{ gridColumn: 'span 3' }}>
        
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px 16px', flexDirection: 'row-reverse' }}>
            <a href="/cardapio" style={{ color: '#666', textDecoration: 'none', fontSize: '0.9rem' }}>Cardápio</a>
            {loja?.configuracoes?.b_delivery === 1 && <a href="/delivery" style={{ color: '#666', textDecoration: 'none', fontSize: '0.9rem' }}>Delivery</a>}
            {loja?.configuracoes?.b_balcao === 1 && <a href="/balcao" style={{ color: '#666', textDecoration: 'none', fontSize: '0.9rem' }}>Balcão</a>}
            <a href="/qr-scanner" style={{ color: '#666', textDecoration: 'none', fontSize: '0.9rem' }}>Ler QR Code</a>
            <span style={{ color: '#666', fontSize: '0.9rem' }}>|</span>
            <a href="#" onClick={(e) => { e.preventDefault(); onMeusPedidosClick?.(); }} style={{ color: '#666', textDecoration: 'none', fontSize: '0.9rem' }}>Meus Pedidos</a>
            <a href="#" onClick={(e) => { e.preventDefault(); onCriarContaClick?.(); }} style={{ color: '#666', textDecoration: 'none', fontSize: '0.9rem' }}>Criar uma conta</a>
            <a href="#" onClick={(e) => { e.preventDefault(); onLoginClick?.(); }} style={{ color: '#666', textDecoration: 'none', fontSize: '0.9rem' }}>Fazer login</a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          © {currentYear} {loja?.nome || 'Grub Digital'}. Todos os direitos reservados. Powered by{' '}
          <a href="https://grub.digital/" target="_blank" rel="noopener noreferrer">
            <img 
              src="https://grubicons.s3.amazonaws.com/logo.svg" 
              alt="Grub Digital" 
              style={{ height: '16px', verticalAlign: 'middle', marginLeft: '4px' }}
            />
          </a>
        </p>
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </footer>
  );
}

export default Footer;
